import React, { useState, useEffect, useCallback, useRef } from "react";
import Header from "../../components/header";
import WelcomeModal from "../../components/welcome-modal";
import styled, { keyframes, css } from "styled-components";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import FunnelStepTypes from "../funnel-step/types";
import Guid from "guid";
import { getIPConfig, getPortalCD, readCookie } from "../../utils/helpers";
import { useDispatch } from "react-redux";
import Loader from "../../components/loader";
import { useTranslation } from "react-i18next";
import {
  AUTISM_SPECTRUM_TEST_ASSESSMENT_ID,
  CAREER_TEST_ASSESSMENT_ID,
  DIFFICULT_PERSON_TEST_ASSESSMENT_ID,
  DISC_TEST_ASSESSMENT_ID,
  DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID,
  DYSLEXIA_SCREENING_CHILDREN_TEST_ASSESSMENT_ID,
  EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID,
  FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID,
  generateContentKey,
  generateContentKeyForAssessment,
  HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID,
  LIKEABILITY_TEST_ASSESSMENT_ID,
  LOVE_STYLE_TEST_ASSESSMENT_ID,
  NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID,
  removeWhitespace,
  wrapScoresWithTraitLevel,
} from "../../utils/general-config";
import { trackEvents } from "../../utils/tracking-events";
import {
  getCookie,
  getQuizColorByIndex,
  getQuizPaddingByIndex,
  REPORT_ROUTES,
} from "../../utils/utility-functions";
import { traitType } from "../../services/enum/environment-enum";
import { APP_NAVIGATION, LOCALE } from "../../utils/constants";
import PathHelper from "../../utils/path-helper";

const PushSelectedAnswerCountToFunnelStep = (count) => ({
  type: FunnelStepTypes.SET_SELECTED_ANSWER_COUNT,
  count,
});

const PushAnswerCountToFunnelStep = (answerCount) => ({
  type: FunnelStepTypes.SET_ANSWER_COUNT,
  answerCount,
});

// const PushBackClickCountToFunnelStep = (backCount) => ({
//   type: FunnelStepTypes.SET_BACk_BUTTON_CLICK_COUNT,
//   backCount,
// });

const PushUserIdToFunnelStep = (userGUID) => ({
  type: FunnelStepTypes.SET_USERID,
  userGUID,
});

const PushAssessmentAttemptIdToFunnelStep = (assessmentAttemptId) => ({
  type: FunnelStepTypes.SET_ASSESSMENT_ATTEMPT_ID,
  assessmentAttemptId,
});
const pushResetSelectedAnswerCountToFunnelStep = () => ({
  type: FunnelStepTypes.RESET_SELECTED_ANSWER_COUNT,
});
const PushAssessmentIdToFunnelStep = (assessmentId) => ({
  type: FunnelStepTypes.SET_ASSESSMENT_ID,
  assessmentId,
});

const QuizB = ({
  getBulkQuestionsConnect,
  saveUserAnswerConnect,
  updateUserAnswerConnect,
  getUserAnswerByAssessmentAttemptIdAndQuestionIdConnect,
  saveAssessmentResultConnect,
  getAssessmentResultByAssessmentAttemptIdConnect,
  funnelStep,
  getAssessmentAttemptConnect,
  createAssessmentAttemptConnect,
  updateAssessmentAttemptConnect,
  IsGuestOrPremiumUserConnect,
  getContentLatestVersionConnect,
  getAssessmentByAssessmentIdConnect,
  createContentMapConnect,
  getUserAnswerByAssessmentAttemptIdConnect,
  getCareerContent,
  getAllAssessmentConnect,
  UpdateUserConnect,
  GetUserByIdConnect,
}) => {
  const newUserId = Guid.create().toString();
  const newAssessmentAttemptId = Guid.create().toString();
  const [modelType, setModelType] = useState("");
  const [userTraits, setUserTraits] = useState([]);
  const [latestVersion, setLatestVersion] = useState("");
  const [savedUserAnswer, setSavedUserAnswer] = useState([]);
  const [careerContent, setCareerContent] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [currentSet, setCurrentSet] = useState(0); // Keep track of the current set of questions
  const questionsPerPage = 10; // Number of questions to display at a time
  // const [previousAnswer, setPreviousAnswer] = useState(null);
  const [shuffledQuestions, setShuffledQuestions] = useState([]);
  const { t } = useTranslation();
  const [userData, setUserData] = useState(null);
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  const signupPath = PathHelper(APP_NAVIGATION.SINU, currentLocale);
  const planPath = PathHelper(APP_NAVIGATION.PLAN, currentLocale);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const {
    totalQuestions,
    selectedAnswerCount,
    userGUID,
    assessmentAttemptId,
    assessmentId,
    totalAnswerCount,
    isQuizComplete,
    countryCD,
    currencyCD,
    ipAddress,
    // backButtonClickCount,
  } = funnelStep || {};

  const ASSESSMENT_ID = queryParams.get("assessmentId") || assessmentId;
  const token = getCookie("jwtToken");
  // const token = localStorage.getItem("jwtToken");

  // const defaultCurrentIndex =
  //   totalQuestions === selectedAnswerCount
  //     ? totalQuestions - 1
  //     : selectedAnswerCount || 0;

  const handleNextSet = () => {
    if (
      currentSet <
      Math.ceil(shuffledQuestions.length / questionsPerPage) - 1
    ) {
      setCurrentSet(currentSet + 1);
    }

    window.scrollTo(0, 0);
    // handleNext();
  };

  const handlePreviousSet = () => {
    if (currentSet > 0) {
      setCurrentSet(currentSet - 1);
    }
    window.scrollTo(0, 0);
  };

  const handleViewReport = (assessmentAttemptId, assessmentId) => {
    const reportRoute = REPORT_ROUTES[assessmentId]; // Dynamically get the route for the given assessmentId
    if (!reportRoute) {
      console.error(`No route found for assessmentId: ${assessmentId}`);
      return;
    }
    const path = PathHelper(reportRoute, currentLocale);
    navigate(`${path.next}?aai=${assessmentAttemptId}&uid=${userGUID}`); // for example
  };

  const navigateToRoute = (token, assessmentAttemptId, navigate) => {
    if (token) {
      handleViewReport(assessmentAttemptId, assessmentId);
    } else {
      navigate(signupPath.next + `?assessmentAttemptId=${assessmentAttemptId}`);
    }
  };

  const userIdRef = useRef(userGUID || newUserId);
  const assessmentAttemptDataIdRef = useRef(
    assessmentAttemptId || newAssessmentAttemptId
  );

  // const [visibleQuestions, setVisibleQuestions] = useState(10);
  const dispatch = useDispatch();
  const [quizData, setQuizData] = useState([]);
  const [userAnswerData, setUserAnswerData] = useState(null);
  const [userAssessmentStage, setUserAssessmentStage] = useState(null);
  const [userAnswer, setUserAnswer] = useState(0);
  const [userAnswers, setUserAnswers] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentQuestion = quizData[currentIndex];
  const [assesmentOptionCount, setAssessmenOptionCount] = useState(0);

  const [animationTrigger, setAnimationTrigger] = useState(false);

  const [assessId, setAssessId] = useState("");
  const navigate = useNavigate();

  const questionRefs = useRef([]);

  const isEqualQueAnsCount = totalQuestions === selectedAnswerCount;

  const submitButtonRef = useRef(null); // Create a ref for the button

  useEffect(() => {
    let isFetched = false; // Flag to track if the API has been called

    if (assessmentAttemptId && savedUserAnswer.length === 0 && !isFetched) {
      isFetched = true; // Set flag to prevent further calls
      if (queryParams.get("newt") == null && !!newAssessmentAttemptId) {
        getUserAnswerByAssessmentAttemptIdConnect(assessmentAttemptId).then(
          (res) => {
            if (res) {
              const givenAnswerData = res.map((item) => ({
                questionId: item.questionId,
                answer: item.answer,
              }));

              setSavedUserAnswer(givenAnswerData);
              setCurrentIndex(givenAnswerData.length);

              if (
                currentSet <
                Math.ceil(givenAnswerData.length / questionsPerPage) - 1
              ) {
                setCurrentSet(
                  Math.ceil(givenAnswerData.length / questionsPerPage) - 1
                );
              }

              const userAnswersMap = givenAnswerData.reduce((acc, item) => {
                acc[item.questionId] = item.answer;
                return acc;
              }, {});

              // Merge the fetched answers with existing answers
              setUserAnswers((prevAnswers) => ({
                ...prevAnswers,
                ...userAnswersMap,
              }));
            }
          }
        );
      }
    }

    return () => {
      isFetched = false; // Reset the flag when the component unmounts
    };
  }, [
    currentSet,
    assessmentAttemptId,
    savedUserAnswer.length,
    currentIndex,
    isEqualQueAnsCount,
    newAssessmentAttemptId,
    queryParams,
    getUserAnswerByAssessmentAttemptIdConnect,
  ]);

  useEffect(() => {
    return () => {
      // Reset the flag when the component unmounts
      setUserAnswers({});
      const savedAnswers = localStorage.removeItem("userAnswers");
      const savedIndex = localStorage.removeItem("currentIndex");
    };
  }, []);

  useEffect(() => {
    if (ASSESSMENT_ID) {
      setIsLoading(true);
      getAllAssessmentConnect().then((response) => {
        if (!!response) {
          const matchedAssessment = response.find(
            (assessment) =>
              assessment.id.toLowerCase() === ASSESSMENT_ID.toLowerCase()
          );
          setAssessmenOptionCount(parseInt(matchedAssessment?.optionCount));
          setIsLoading(false);
        }
      });
    }
  }, [getAllAssessmentConnect, ASSESSMENT_ID]);

  useEffect(() => {
    if (submitButtonRef.current && isAllQuestionsAnswered()) {
      // Scroll to the button smoothly when all questions are answered
      submitButtonRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [userAnswers]); // Trigger scroll when answers change and the button appears

  useEffect(() => {
    if (questionRefs.current[currentIndex]) {
      questionRefs.current[currentIndex].scrollIntoView({
        behavior: "smooth",
        block: "center", // Center the active question in the viewport
      });
    } else {
    }
  }, [currentIndex]);

  useEffect(() => {
    setIsLoading(true);
    setAssessId(assessmentId);
    if (queryParams.get("assessmentId"))
      setAssessId(queryParams.get("assessmentId"));
    let ipAddressValue = ipAddress;
    if (!ipAddressValue) {
      getIPConfig(dispatch);
    }
    trackEvents("quizView", {
      userGuid: userGUID,
      eventLabel: "Page View",
      assessmentAttemptId: assessmentAttemptId,
      countryCD: countryCD,
      currencyCD: currencyCD,
      visitId: readCookie("visitGuid"),
      visitorId: readCookie("visitorGuid"),
      portalCD: getPortalCD(),
    });
  }, []);
  useEffect(() => {
    if (token && userGUID) {
      IsGuestOrPremiumUserConnect(userGUID).then((res) => {
        if (res && res?.isPremiumOrGuestUser === false) {
          navigate(planPath.next);
        }
      });
      GetUserByIdConnect(userGUID).then((res) => {
        if (res) {
          setUserData(res);
        }
      });
    }
  }, [userGUID, token]);

  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (selectedAnswerCount > 0 || token) {
      setIsModalOpen(false);
      setIsModalOpen(false);
    }
  }, [selectedAnswerCount, token]);

  //Dont know if we are using this V
  useEffect(() => {
    if (!!assessId) {
      getBulkQuestionsConnect(assessId, currentLocale)
        .then((response) => {
          if (response) {
            setQuizData(
              response?.map((item, index) => {
                return {
                  ...item,
                  questionIndex: index,
                };
              })
            );
            dispatch(PushUserIdToFunnelStep(userIdRef.current));
            if (queryParams.get("assessmentId")) {
              dispatch(
                PushAssessmentIdToFunnelStep(queryParams.get("assessmentId"))
              );
            }
            if (queryParams.get("newt") && !!newAssessmentAttemptId) {
              dispatch(
                PushAssessmentAttemptIdToFunnelStep(newAssessmentAttemptId)
              );
              dispatch(pushResetSelectedAnswerCountToFunnelStep());
              if (assessmentAttemptDataIdRef.current) {
                assessmentAttemptDataIdRef.current =
                  newAssessmentAttemptId.toString();
              }
              const currentUrl = new URL(window.location.href);
              currentUrl.searchParams.delete("newt"); // Remove the "newt" query param

              // Update the browser's history without reloading the page
              window.history.replaceState(null, "", currentUrl.toString());
            } else {
              dispatch(
                PushAssessmentAttemptIdToFunnelStep(
                  assessmentAttemptDataIdRef.current
                )
              );
            }
          } else {
            navigateToRoute(token, assessmentAttemptId, navigate);
          }
        })
        .catch((error) => {
          console.error("getBulkQuestionsConnect failed", error);
          setIsLoading(false);
        });
      if (queryParams.get("newt") == null && !!newAssessmentAttemptId) {
        getAssessmentStage();
      }
    }
  }, [assessId]);

  const handleNext = () => {
    const nextQuestionIndex = currentIndex + 1;

    if (nextQuestionIndex < totalQuestions) {
      // Normal behavior for next question
      setAnimationTrigger(true);

      setCurrentIndex(nextQuestionIndex);
      setAnimationTrigger(false);
    }
    // No longer submitting here
  };

  const handleAnswerChange = (e, questionId, questionIndex) => {
    if (isProcessing) return;

    setIsProcessing(true);
    const { value } = e.target;

    // Update the answers in local state
    setUserAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionId]: Number(value),
    }));

    // Prepare user answer data for API
    let userAnswerData = {
      assessmentAttemptId: assessmentAttemptId,
      userId: userIdRef.current,
      questionId: questionId,
      assessmentId: assessId,
      answer: value,
    };
    let userStageData = {
      userId: userIdRef.current,
      asessmentId: assessId,
      assessmentAttemptId: assessmentAttemptId,
      assessmentStep: 1,
      resumeQuestionId: currentIndex + 1,
    };

    const isExistingAnswer = savedUserAnswer.some(
      (item) => item.questionId === questionId
    );

    // setCurrentIndex(savedUserAnswer.length);

    // Decide whether to save or update the answer
    const processAnswer = isExistingAnswer
      ? updateUserAnswerConnect(userAnswerData)
      : saveUserAnswerConnect(userAnswerData);

    processAnswer
      .then(() => {
        // Update savedUserAnswer in state
        setSavedUserAnswer((prev) =>
          isExistingAnswer
            ? prev.map((item) =>
                item.questionId === questionId
                  ? { ...item, answer: Number(value) }
                  : item
              )
            : [...prev, { questionId, answer: Number(value) }]
        );

        // Update funnel steps
        if (!isExistingAnswer) {
          setCurrentIndex(currentIndex + 1);
          dispatch(PushAnswerCountToFunnelStep(currentIndex + 1));
          dispatch(PushSelectedAnswerCountToFunnelStep(currentIndex + 1));
        }

        // Handle next question if needed
        if (questionIndex === currentIndex) {
          handleNext();
        }

        setIsProcessing(false);
      })
      .catch(() => {
        setIsProcessing(false); // Reset processing state on error
      });

    // Create or update assessment attempt
    if (!isExistingAnswer) {
      if (currentIndex + 1 === 1) {
        createAssessmentAttemptConnect(userStageData).then((response) => {});
      } else {
        updateAssessmentAttemptConnect(userStageData).then((response) => {});
      }
    }
  };

  const getAssessmentStage = () => {
    getAssessmentAttemptConnect(
      assessId,
      userIdRef.current,
      assessmentAttemptDataIdRef.current
    ).then((response) => {
      if (!!response) {
        const { resumeQuestionId } = response;
        if (!!resumeQuestionId) {
          setCurrentIndex(resumeQuestionId);
        } else {
          setCurrentIndex(0); // Force the start of the quiz at 0 for testing
        }
      }
      setIsLoading(false);
    });
  };

  const fetchAssessmentResult = useCallback(() => {
    if (!!assessmentAttemptId) {
      return getAssessmentResultByAssessmentAttemptIdConnect(
        assessmentAttemptId
      ).then((res) => {
        if (res) {
          setUserTraits(res?.userTraits);
          setModelType(res?.modelType);
          return res; // Return the result here
        }
      });
    }
    return Promise.resolve(null); // Return null if `assessmentAttemptId` is falsy
  }, [assessmentAttemptId]);

  const handleSubmit = () => {
    if (isQuizComplete) {
      navigateToRoute(token, assessmentAttemptId, navigate);
    } else {
      setIsLoading(true);
      saveAssessmentResultConnect(assessmentAttemptId).then(
        async (response) => {
          const personalityId = response?.personality?.id;
          if (response) {
            if (assessId === CAREER_TEST_ASSESSMENT_ID) {
              navigateToRoute(token, assessmentAttemptId, navigate);
            } else {
              setUserTraits(response?.userTraits);
              let contentKey = "";
              if (response?.traitType === traitType.OPPOSITE) {
                const mappedUserTrait =
                  response?.userTraits.length > 0
                    ? wrapScoresWithTraitLevel(response?.userTraits)
                    : [];
                contentKey = generateContentKey(mappedUserTrait);
              } else if (
                response?.traitType === traitType.ONLYSUM &&
                assessId.toLowerCase() !==
                  LIKEABILITY_TEST_ASSESSMENT_ID.toLowerCase() &&
                assessId.toLowerCase() !==
                  DISC_TEST_ASSESSMENT_ID.toLowerCase() &&
                assessId.toLowerCase() !==
                  EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID.toLowerCase() &&
                assessId.toLowerCase() !==
                  DIFFICULT_PERSON_TEST_ASSESSMENT_ID.toLowerCase() &&
                assessId.toLowerCase() !==
                  AUTISM_SPECTRUM_TEST_ASSESSMENT_ID.toLowerCase() &&
                assessId.toLowerCase() !==
                  HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID.toLowerCase() &&
                assessId.toLowerCase() !==
                  DYSLEXIA_SCREENING_CHILDREN_TEST_ASSESSMENT_ID.toLowerCase() &&
                assessId.toLowerCase() !==
                  DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID.toLowerCase() &&
                assessId.toLowerCase() !==
                  LOVE_STYLE_TEST_ASSESSMENT_ID.toLowerCase() &&
                assessId.toLowerCase() !==
                  NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID.toLowerCase() &&
                assessId.toLowerCase() !==
                  FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID.toLowerCase()
              ) {
                const mappedUserTrait =
                  response?.userTraits.length > 0 && response?.userTraits;
                contentKey = generateContentKeyForAssessment(
                  mappedUserTrait,
                  assessId
                );
              } else if (
                response?.traitType === traitType.ONLYSUM &&
                (assessId.toLowerCase() ===
                  LIKEABILITY_TEST_ASSESSMENT_ID.toLowerCase() ||
                  assessId.toLowerCase() ===
                    DISC_TEST_ASSESSMENT_ID.toLowerCase() ||
                  assessId.toLowerCase() ===
                    EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID.toLowerCase() ||
                  assessId.toLowerCase() ===
                    DIFFICULT_PERSON_TEST_ASSESSMENT_ID.toLowerCase() ||
                  assessId.toLowerCase() ===
                    AUTISM_SPECTRUM_TEST_ASSESSMENT_ID.toLowerCase() ||
                  assessId.toLowerCase() ===
                    HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID.toLowerCase() ||
                  assessId.toLowerCase() ===
                    DYSLEXIA_SCREENING_CHILDREN_TEST_ASSESSMENT_ID.toLowerCase() ||
                  assessId.toLowerCase() ===
                    DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID.toLowerCase() ||
                  assessId.toLowerCase() ===
                    LOVE_STYLE_TEST_ASSESSMENT_ID.toLowerCase() ||
                  assessId.toLowerCase() ===
                    NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID ||
                  assessId.toLowerCase() ===
                    FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID.toLowerCase())
              ) {
                contentKey = "ALL_CONTENT";
              } else {
                contentKey = "ALL_CONTENT";
              }
              if (token) {
                const resultResposne = await fetchAssessmentResult();
                // Get the latest content version based on modelType and contentKey
                getContentLatestVersionConnect({
                  modelType: resultResposne.modelType,
                  contentKey: contentKey,
                })
                  .then((latestVersionResponse) => {
                    if (latestVersionResponse) {
                      // Proceed with content map creation using the version received
                      const contentMapData = {
                        userGuid: userGUID,
                        contentKey: contentKey,
                        modelType: removeWhitespace(resultResposne.modelType),
                        assessmentAttemptId: assessmentAttemptId,
                        version: latestVersionResponse, // Using the direct response here
                      };

                      // Ensure all required parameters are present
                      if (userGUID && contentKey && assessmentAttemptId) {
                        createContentMapConnect(contentMapData)
                          .then((res) => {
                            // Handle success, if needed
                            setIsLoading(false);
                            navigateToRoute(
                              token,
                              assessmentAttemptId,
                              navigate
                            );
                            // navigate(ROUTE_CONSTANT.DASHBOARD);
                          })
                          .catch((err) => {
                            // Handle any errors in createContentMapConnect
                            console.error("Error creating content map:", err);
                          });
                      } else {
                        console.error(
                          "Missing required parameters for createContentMapConnect"
                        );
                      }
                    }
                  })
                  .catch((err) => {
                    // Handle any errors from getContentLatestVersionConnect
                    console.error("Error fetching latest version:", err);
                  });
              } else {
                // If no token, navigate to the signup page
                navigateToRoute(token, assessmentAttemptId, navigate);
                // navigate(
                //   ROUTE_CONSTANT.SIGNUP +
                //     `?assessmentAttemptId=${assessmentAttemptId}`
                // );
              }
            }
          }
        }
      );
    }
  };

  const quizRef = useRef(null);

  // Assuming currentIndex is updated when the user goes to the next question
  useEffect(() => {
    if (totalQuestions !== selectedAnswerCount) {
      setUserAnswer(0);
    }
  }, [currentIndex, totalQuestions, selectedAnswerCount]);

  const isAllQuestionsAnswered = () => {
    return Object.keys(userAnswers).length === totalQuestions;
  };

  const renderCompleteTestButton = () => {
    return (
      <div className="flex justify-center items-center mt-7 mb-24 ">
        <button
          onClick={handleSubmit}
          ref={submitButtonRef} // Attach the ref to the button
          className="bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 text-white transition-colors py-3 rounded-3xl px-8 text-xl font-bold uppercase tracking-wider flex items-center gap-3"
        >
          {t("quiz.get_result_Cta")}
          <svg
            className="fill-white inline-block"
            width="24"
            height="24"
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            clip-rule="evenodd"
          >
            <path d="M12 0c-6.623 0-12 5.377-12 12s5.377 12 12 12 12-5.377 12-12-5.377-12-12-12zm0 1c-6.071 0-11 4.929-11 11s4.929 11 11 11 11-4.929 11-11-4.929-11-11-11zm4.828 11.5l-4.608 3.763.679.737 6.101-5-6.112-5-.666.753 4.604 3.747h-11.826v1h11.828z" />
          </svg>
        </button>
      </div>
    );
  };

  //Adding classes to Navbar
  useEffect(() => {
    const navbar = document.querySelector(".navbar");
    if (navbar) {
      navbar.classList.add("sticky", "top-0", "w-full", "z-[99]");
    }

    return () => {
      if (navbar) {
        navbar.classList.remove("sticky", "top-0", "w-full", "z-[99]");
      }
    };
  }, []); // Only runs on mount and unmount

  //Adding position absolute to footer on mobile
  useEffect(() => {
    const footer = document.querySelector("footer");

    if (footer) {
      footer.classList.add("hidden", "sm:block");
    }

    return () => {
      if (footer) {
        footer.classList.remove("hidden", "sm:block");
      }
    };
  }, []);

  //moving logo on mobile
  useEffect(() => {
    const footer = document.querySelector(".logo_it");

    if (footer) {
      footer.classList.add("mx-auto", "scale-75", "sm:scale-100");
    }

    return () => {
      if (footer) {
        footer.classList.remove("mx-auto", "scale-75", "sm:scale-100");
      }
    };
  }, []);

  // Add a state for tracking gender selection
  const [gender, setGender] = useState("");

  // Function to handle gender selection
  const handleGenderSelection = (e) => {
    localStorage.setItem("gender", e.target.value);
    setGender(e.target.value);
    if (userData && !userData?.gender) {
      const data = {
        ...userData,
        gender: e.target.value || userData?.gender,
      };

      UpdateUserConnect(data).then((res) => {});
    }
  };

  // Ref for gender section
  const genderSectionRef = useRef(null);

  // Add effect to scroll to gender section once all questions are completed
  useEffect(() => {
    if (isAllQuestionsAnswered() && genderSectionRef.current) {
      genderSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center", // Adjust based on how you want it to align
      });
    }
  }, [userAnswers]); // Triggers when answers change

  // Function to render gender section
  const renderGenderSection = () => (
    <div className="flex flex-col justify-center items-center mt-3 h-60 max-w-3xl sm:max-w-full mb-20">
      <p className="mb-3 text-base text-center sm:text-2xl font-semibold text-[#444C5E] max-w-2xl w-full">
        {t("quiz.gender_text")}
      </p>
      <p className="text-gray-500 text-base text-center">
        {t("quiz.gender_content_one")}
        <br></br>
        {t("quiz.gender_content_two")}
      </p>
      <div className="flex gap-4 justify-center items-center mt-7">
        <label
          className={`cursor-pointer px-6 py-2 border-2 text-gray-700 font-bold ${
            gender === "male"
              ? "bg-[#805AED] text-white"
              : "bg-white text-[#805AED]"
          } border-[#805AED] rounded-3xl`}
        >
          <input
            type="radio"
            name="gender"
            value="male"
            className="hidden" // Hide the default radio input
            checked={gender === "male"}
            onChange={handleGenderSelection}
          />
          {t("quiz.male")}
        </label>

        <label
          className={`cursor-pointer px-6 py-2 border-2 text-gray-700 font-bold ${
            gender === "female"
              ? "bg-[#805AED] text-white"
              : "bg-white text-[#805AED]"
          } border-[#805AED] rounded-3xl`}
        >
          <input
            type="radio"
            name="gender"
            value="female"
            className="hidden"
            checked={gender === "female"}
            onChange={handleGenderSelection}
          />
          {t("quiz.female")}
        </label>

        <label
          className={`cursor-pointer px-6 py-2 border-2 text-gray-700 font-bold ${
            gender === "other"
              ? "bg-[#805AED] text-white"
              : "bg-white text-[#805AED]"
          } border-[#805AED] rounded-3xl`}
        >
          <input
            type="radio"
            name="gender"
            value="other"
            className="hidden"
            checked={gender === "other"}
            onChange={handleGenderSelection}
          />
          {t("quiz.other")}
        </label>
      </div>
    </div>
  );

  //Add relative to root
  useEffect(() => {
    const root = document.querySelector("#root");

    if (root) {
      root.classList.add("relative"); // Add 'relative' to root to position child elements
    }

    return () => {
      if (root) {
        root.classList.remove("relative"); // Clean up by removing the 'relative' class
      }
    };
  }, []);

  // Save currentIndex to localStorage whenever it changes
  useEffect(() => {
    if (currentIndex !== null && currentIndex >= 0) {
      localStorage.setItem("currentIndex", currentIndex);
    }
  }, [currentIndex]);

  // Save user answers to localStorage whenever they change
  useEffect(() => {
    if (userAnswers && Object.keys(userAnswers).length > 0) {
      localStorage.setItem("userAnswers", JSON.stringify(userAnswers));
    }
  }, [userAnswers]);

  // Restore state (currentIndex and userAnswers) once quizData is loaded
  useEffect(() => {
    if (quizData.length > 0) {
      const savedAnswers = localStorage.getItem("userAnswers");
      const savedIndex = localStorage.getItem("currentIndex");

      if (savedAnswers) {
        try {
          const parsedAnswers = JSON.parse(savedAnswers);
          setUserAnswers(parsedAnswers);
          // Restore currentIndex based on the number of answered questions
          const answeredQuestions = Object.keys(parsedAnswers).length;
          setCurrentIndex(Number(savedIndex) || answeredQuestions); // Prefer the saved index, or fallback to answered questions count
        } catch (error) {
          console.error("Failed to parse userAnswers from localStorage", error);
        }
      }
    }
  }, [quizData]);

  useEffect(() => {
    if (questionRefs.current[currentIndex]) {
      questionRefs.current[currentIndex].scrollIntoView({
        behavior: "smooth",
        block: "center", // Center the active question in the viewport
      });
    }
  }, [currentIndex, quizData]); // Ensure it runs after quizData is loaded

  useEffect(() => {
    // Remove currentIndex and userAnswers from localStorage when the quiz is completed
    if (isQuizComplete) {
      localStorage.removeItem("currentIndex");
      localStorage.removeItem("userAnswers");
    }
  }, [isQuizComplete]);

  const isCurrentSetComplete = () => {
    return shuffledQuestions
      .slice(currentSet * questionsPerPage, (currentSet + 1) * questionsPerPage)
      .every((question) => userAnswers[question.id] !== undefined);
  };

  useEffect(() => {
    if (savedUserAnswer.length > 0) {
      // Separate answered and unanswered questions
      const answered = quizData?.filter((question) =>
        savedUserAnswer.some(
          (savedAnswer) => savedAnswer.questionId === question.id
        )
      );
      const unanswered = quizData?.filter(
        (question) =>
          !savedUserAnswer.some(
            (savedAnswer) => savedAnswer.questionId === question.id
          )
      );

      // Combine answered questions first, followed by unanswered questions
      const reorderedQuestions = [...answered, ...unanswered];

      // Set the reordered list of questions with an index
      setShuffledQuestions(
        reorderedQuestions.map((item, index) => ({
          ...item,
          questionIndex: index,
        }))
      );
    } else {
      // Use quizData as-is and add questionIndex
      setShuffledQuestions(
        quizData?.map((item, index) => ({
          ...item,
          questionIndex: index,
        }))
      );
    }
  }, [quizData, savedUserAnswer.length > 0]);

  return (
    <>
      <WelcomeModal isOpen={isModalOpen} onClose={handleCloseModal} />
      <Header />
      <div className="flex justify-center items-center" ref={quizRef}>
        <Loader isLoading={isLoading} />
        <Container>
          <div
            className="quiz-container w-full"
            style={{ overflowY: "auto" }}
            ref={quizRef}
          >
            {/* Displaying the current set of 10 questions */}
            {shuffledQuestions
              .slice(
                currentSet * questionsPerPage,
                (currentSet + 1) * questionsPerPage
              )
              .map((question, index) => {
                return (
                  <QuestionContainer
                    ref={(el) => {
                      if (el) {
                        questionRefs.current[question.questionIndex] = el; // Ensure each question gets a ref
                      }
                    }}
                    className={
                      currentIndex === question.questionIndex
                        ? "opacity-100 scale-90 lg:scale-100 transition-all duration-500 ease-in-out border-b border-gray-400 sm:border-0"
                        : "opacity-20 scale-[85%] lg:scale-90 transition-all duration-500 ease-in-out border-b border-gray-400 sm:border-0"
                    }
                    key={question.id}
                  >
                    <form className="flex flex-col justify-center items-center h-60 container max-w-3xl sm:max-w-full">
                      <Question
                        className="text-center mb-2"
                        animation={animationTrigger}
                      >
                        <h5 className="text-base sm:text-2xl font-semibold text-[#444C5E] max-w-2xl w-full">
                          {question.title_EN}
                        </h5>
                      </Question>

                      {/* Input Options */}
                      <LabelContainer className="flex-col md:flex-row relative items-end md:items-center mb-28 max-w-screen-sm sm:max-w-full">
                        <LabelText className="text-[#36A2B8] absolute left-0 md:left-auto bottom-0 md:bottom-auto md:relative">
                          {t("quiz.disagree")}
                        </LabelText>
                        <CircleContainer className="mx-auto mb-3 flex md:gap-5 sm:gap-4 gap-2">
                          {Array?.from(Array(assesmentOptionCount), (_, i) => (
                            <label key={i} className="text-center">
                              <input
                                type="radio"
                                name={`question-${question.id}`}
                                className="hidden"
                                onChange={(e) =>
                                  handleAnswerChange(
                                    e,
                                    question.id,
                                    question.questionIndex
                                  )
                                }
                                checked={userAnswers[question.id] === i + 1}
                                value={i + 1}
                                disabled={
                                  question.questionIndex > currentIndex ||
                                  isQuizComplete
                                }
                              />
                              <div
                                className={`rounded-full p-0 flex mx-0 justify-center items-center border-2 ${
                                  isQuizComplete ||
                                  question.questionIndex > currentIndex
                                    ? "cursor-not-allowed"
                                    : "cursor-pointer"
                                }
                          ${getQuizPaddingByIndex(i, assesmentOptionCount)} 
                          bg-[#f5f5f5] hover:bg-insightful-light-purple transition-all duration-300`}
                                style={{
                                  borderColor:
                                    userAnswers[question.id] === i + 1
                                      ? "#805AED"
                                      : getQuizColorByIndex(
                                          i,
                                          assesmentOptionCount
                                        ).color,
                                  backgroundColor:
                                    userAnswers[question.id] === i + 1
                                      ? "#805AED"
                                      : "", // Use the same color for the background
                                }}
                              >
                                {/* Display checkmark if answer is selected */}
                                {userAnswers[question.id] === i + 1 && (
                                  <span>
                                    <svg
                                      className="w-7 fill-white"
                                      clip-rule="evenodd"
                                      fillRule="evenodd"
                                      stroke-linejoin="round"
                                      stroke-miterlimit="2"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="m2.25 12.321 7.27 6.491c.143.127.321.19.499.19.206 0 .41-.084.559-.249l11.23-12.501c.129-.143.192-.321.192-.5 0-.419-.338-.75-.749-.75-.206 0-.411.084-.559.249l-10.731 11.945-6.711-5.994c-.144-.127-.322-.19-.5-.19-.417 0-.75.336-.75.749 0 .206.084.412.25.56"
                                        fillRule="nonzero"
                                      />
                                    </svg>
                                  </span>
                                )}
                              </div>
                            </label>
                          ))}
                        </CircleContainer>
                        <LabelText className="text-[#53AF65]">
                          {" "}
                          {t("quiz.agree")}
                        </LabelText>
                      </LabelContainer>
                    </form>
                  </QuestionContainer>
                );
              })}

            {/* Show Gender Section and Complete Test Button after all questions are answered */}
            {isAllQuestionsAnswered() &&
              !isLoading &&
              !token &&
              renderGenderSection()}
            {isAllQuestionsAnswered() &&
              !isLoading &&
              renderCompleteTestButton()}

            {/* Pagination Controls */}
            <div className="flex justify-center items-center gap-7 pb-20 md:pb-15">
              {isCurrentSetComplete() && !isAllQuestionsAnswered() && (
                <>
                  <button
                    onClick={handlePreviousSet}
                    disabled={currentSet === 0}
                    className={`px-4 py-2 rounded-md text-white transition duration-300 ${
                      currentSet === 0
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-900 focus:ring-opacity-50"
                    }`}
                  >
                    {t("quiz.previous")}
                  </button>

                  <button
                    className={`px-4 py-2 rounded-md text-white transition duration-300 ${
                      currentSet ===
                      Math.ceil(shuffledQuestions?.length / questionsPerPage) -
                        1
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-900 focus:ring-opacity-50"
                    }`}
                    onClick={handleNextSet}
                    disabled={
                      currentSet ===
                      Math.ceil(shuffledQuestions.length / questionsPerPage) - 1
                    }
                  >
                    {t("quiz.next")}
                  </button>
                </>
              )}
            </div>
          </div>
        </Container>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default QuizB;

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  items: center;
  flex-direction: column;
  padding: 0 15px;
`;

const LabelContainer = styled.div`
  display: flex;
  margin: 1rem 0;
`;

const LabelText = styled.div`
  font-size: 1rem;
  font-weight: bold;
  white-space: nowrap;
  margin: 0 1rem;
`;

const CircleContainer = styled.div`
  display: flex;
  align-items: center;
`;

// const ButtonContainer = styled.div`
//   display: flex;
//   justify-content: ${({ currentIndex }) =>
//     currentIndex === 0 ? "flex-end" : "space-between"};
//   padding-left: 1rem;
//   width: 100%;
// `;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const QuestionContainer = styled.div``;

// const QuestionContainer = styled.div`
//   animation: ${fadeIn} 0.5s ease-in-out forwards;
//   opacity: 1;
//   ${(props) =>
//     props.animation &&
//     css`
//       animation-delay: ${props.animation * 0.5}s;
//       animation-fill-mode: forwards;
//     `}
// `;
const Question = styled.div`
  ${({ animation }) =>
    animation
      ? css`
          animation: ${fadeIn} 0.5s ease-in-out forwards;
        `
      : ""}
  opacity: 0.5s;
`;
